/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockFastIcon20Regular = forwardRef('TimeClockFastIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.578 9a6.5 6.5 0 0 1 12.92 1c0 3.59-2.909 6.499-6.498 6.499v1.5A7.999 7.999 0 1 0 2.063 9h1.515Z" }),
        React.createElement("path", { d: "M1.5 10.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z" }),
        React.createElement("path", { d: "M.25 14a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 14Z" }),
        React.createElement("path", { d: "M.75 17a.75.75 0 0 1 .75-.75H8a.75.75 0 0 1 0 1.5H1.5A.75.75 0 0 1 .75 17Z" }),
        React.createElement("path", { d: "M10.48 6.443a.75.75 0 0 0-1.5 0v3.123a2 2 0 0 0 1.085 1.78l2.693 1.383a.75.75 0 1 0 .685-1.334l-2.692-1.384a.5.5 0 0 1-.272-.445V6.443Z" })));
});
